import CryptoJS from 'crypto-js';

export const encodeBase64 = (value) => {
    const array = CryptoJS.enc.Utf8.parse(value);
    return CryptoJS.enc.Base64.stringify(array);
};

export const decodeBase64 = (value) => {
    const array = CryptoJS.enc.Base64.parse(value);
    return array.toString(CryptoJS.enc.Utf8);
};
